"use client";

import React from "react";
import clsx from "clsx";
import { StepperCircleOutline, StepperCircle, StepperCheckmark } from "components/icons";

interface Props {
    status: string;
    statusSteps: { label: string }[];
    currentStatusIndex: number;
    DOT_OFFSET: number;
    cartKind?: string;
}

const OrderStepperComponent: React.FC<Props> = ({
    status,
    statusSteps,
    currentStatusIndex,
    DOT_OFFSET,
    cartKind,
}) => {
    const totalSteps = statusSteps?.length;
    if (!statusSteps || totalSteps === 0) return null;
    
    const progressPercent =
    totalSteps > 1
    ? (currentStatusIndex / (totalSteps - 1)) * 100
    : 0;

    const offsetValueMapper: Record<number, number> = {
        0: 0,
        1: -2,
        2: -1,
        3: cartKind=='m2hCart'?0:1,
        4: cartKind=='m2hCart'?0:1,
        5: 0,
    };

    const offsetValue = offsetValueMapper[currentStatusIndex] ?? 0;
    const m2hWidthIndexWise=currentStatusIndex>2? 'w-auto':'w-50';

    return (
        <div className="p-12 sm:p-16">
            <p className="mb-12 text-14 lg:text-16 font-bold text-gray-700" data-ffid="lbl-stepper-status">
                {status}
            </p>

            <div className="relative" data-testid="ctr-stepper" data-ffid="ctr-stepper">

                <div
                    className="absolute top-7 h-4 bg-[#ADADAD]"
                    style={{ left: DOT_OFFSET, right: DOT_OFFSET }}
                    data-ffid="ctr-stepper-grey-line"
                />

                {/* Green progress line */}
                <div
                    className="absolute top-7 h-4 bg-green-success-green transition-all duration-300"
                    style={{
                        width:`${progressPercent - offsetValue}%`,
                    }}
                />

                {/* status Steps */}
                <ol className="relative flex w-full justify-between">
                    {statusSteps.map((step, idx) => {
                        const isCompleted = (currentStatusIndex===statusSteps?.length-1)?true: idx < currentStatusIndex;
                        const isActive = (currentStatusIndex===statusSteps?.length-1)?false:idx === currentStatusIndex;

                        return (
                            <li key={step.label} className="flex flex-col items-center" data-testid={`ctr-stepper-item-${idx}`}  data-ffid={`ctr-stepper-item-${idx}`}>
                                <div
                                    className={clsx(
                                        "flex size-16 items-center justify-center",
                                        // idx === 0 && "-translate-x-[25px]",
                                        idx === 0 && "self-start",
                                        (idx >0 && idx<(statusSteps.length - 1)) && ' self-center',
                                        // idx === statusSteps.length - 1 && "translate-x-[30px]"
                                        idx === statusSteps.length - 1 && "self-end"
                                    )}
                                    data-ffid={`ctr-stepper-dot-${idx}`}
                                >
                                    {isActive && <StepperCircleOutline className="text-[#333333]" dimension={16} />}
                                    {!isActive && !isCompleted && <StepperCircle className="text-[#B3B3B3]" dimension={16} />}
                                    {isCompleted && <StepperCheckmark className="text-green-success-green" dimension={16} />}
                                </div>

                                <span
                                    className={clsx(
                                        "mt-12 text-center text-10 lg:text-12 px-2",
                                        isCompleted && "text-[#333333]",
                                        isActive && "font-bold text-black",
                                        !isCompleted && !isActive && "text-[#5C5C5C]",
                                        cartKind=='m2hCart'?m2hWidthIndexWise:('w-50'),
                                    )}
                                    data-testid={`lbl-stepper-label-${idx}`}
                                    data-ffid={`lbl-stepper-label-${idx}`}
                                >
                                    {step.label}
                                </span>
                            </li>
                        );
                    })}
                </ol>
            </div>
        </div>
    );
};

export default OrderStepperComponent;